import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SigninComponent } from './signin/signin.component'
import { RouterModule } from '@angular/router'
import { SigninFormComponent } from './signin-form/signin-form.component'
import { OtpInputModule } from 'src/app/shared/otp-input/otp-input.module'
import { ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { MultiFactorAuthenticationComponent } from './multi-factor-authentication/multi-factor-authentication.component'
import { RecoveryPinComponent } from './recovery-pin/recovery-pin.component'
import { SanitizerModule } from 'src/app/shared/sanitizer/sanitizer.module'
import { AdRedirectionComponent } from './ad-redirection/ad-redirection.component'
import { InputTrimModule } from 'src/app/shared/directives/input-trim/input-trim.module'

@NgModule({
  declarations: [SigninComponent, SigninFormComponent,MultiFactorAuthenticationComponent, RecoveryPinComponent, AdRedirectionComponent],
  imports: [
    OtpInputModule,
    InputTrimModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    SanitizerModule,
    RouterModule.forChild([{ path: '', component: SigninComponent }])
  ],
})
export class SigninModule {}
